import Metrics from "./pages/Metrics.vue";

// eslint-disable-next-line no-unused-vars
export function metricsModule({ app, router, store, eventBus }) {
  router.addRoute("Home", {
    path: "metrics",
    name: "metrics",
    component: () => import("@/components/ParentNode"),
    redirect: (to) => {
      return to.path + "/list";
    },
  });

  router.addRoute("metrics", { path: "data", component: Metrics });
}
